import Images from '../assets/img';

export const caseStudyContent = [
  {
    id: 'zeliot',
    backGroundColor: 'black',
    foreGroundImage: Images.caseStudyPage.caseStudyPageBannerImg,
    icon: Images.caseStudyPage.zeliotImg,
    customerOneLiner: 'ZELIOT_DETAILS.COMPANY_TITLE_TAG',
    customerDescription: 'ZELIOT_DETAILS.COMPANY_BODY_TEXT',
    iconClass: 'custom-style-img-1',
    name: 'ZELIOT_DETAILS.COMPANY_TITLE',
    description: 'ZELIOT_DETAILS.COMPANY_DESCRIPTION',
    companyLogo: Images.caseStudyPage.zeliotImg,
    cioImage: Images.caseStudyPage.zeliotCioImg,
    challenges: [
      {
        text: 'ZELIOT_DETAILS.CHALLENGES.TEXT_1'
      },
      {
        text: 'ZELIOT_DETAILS.CHALLENGES.TEXT_2'
      }
    ],
    solutions: [
      {
        heading: 'ZELIOT_DETAILS.SOLUTION_1',
        description: [
          {
            text: 'ZELIOT_DETAILS.SOLUTIONS.TEXT_1'
          },
          {
            text: 'ZELIOT_DETAILS.SOLUTIONS.TEXT_2'
          }
        ]
      },
      {
        heading: 'ZELIOT_DETAILS.SOLUTION_2',
        description: [
          {
            text: 'ZELIOT_DETAILS.SOLUTIONS.TEXT_3'
          }
        ]
      }
    ],
    result: [
      {
        text: 'ZELIOT_DETAILS.RESULT.TEXT_1'
      },
      {
        text: 'ZELIOT_DETAILS.RESULT.TEXT_2'
      },
      {
        text: 'ZELIOT_DETAILS.RESULT.TEXT_3'
      }
    ],
    testimonials: {
      text: 'ZELIOT_DETAILS.TESTIMONIALS.TEXT1',
      person: 'ZELIOT_DETAILS.TESTIMONIALS.PERSON'
    },
    companyCategories: [
      {
        logo: Images.caseStudyPage.customerIcon,
        heading: 'SHARED.CUSTOMER',
        text: 'ZELIOT_DETAILS.COMPANY_NAME'
      },
      {
        logo: Images.caseStudyPage.industryImg,
        heading: 'SHARED.INDUSTRY',
        text: 'ZELIOT_DETAILS.INDUSTRY'
      },
      {
        logo: Images.caseStudyPage.countryImg,
        heading: 'SHARED.COUNTRY',
        text: 'ZELIOT_DETAILS.COUNTRY'
      },
      {
        logo: Images.caseStudyPage.segmentImg,
        heading: 'SHARED.SEGMENT',
        text: 'ZELIOT_DETAILS.ENTERPRISE'
      },
      {
        logo: Images.caseStudyPage.websiteLinkImg,
        heading: 'SHARED.WEBSITE',
        text: 'ZELIOT_DETAILS.WEBSITE_LINK'
      }
    ]
  },
  {
    id: 'sahaj-retail',
    backGroundColor: 'black',
    foreGroundImage: Images.caseStudyForeGroundImg2,
    icon: Images.caseStudyPage.sahajRetailImg,
    customerOneLiner: 'SAHAJ_RETAIL_DETAILS.COMPANY_TITLE_TAG',
    customerDescription: 'SAHAJ_RETAIL_DETAILS.COMPANY_BODY_TEXT',
    iconClass: 'custom-style-img-2',
    iconClassResponsive: 'custom-style-img-2-responsive',
    name: 'SAHAJ_RETAIL_DETAILS.COMPANY_TITLE',
    description: 'SAHAJ_RETAIL_DETAILS.COMPANY_DESCRIPTION',
    companyLogo: 'https://play-lh.googleusercontent.com/h5pUxPa6zu0wyw2NxiEVoCtuUcpQze1LxWDnY4GsbJBT6c_kaaX805D96GN791n-Nww',
    challenges: [
      {
        text: 'SAHAJ_RETAIL_DETAILS.CHALLENGES.TEXT_1'
      },
      {
        text: 'SAHAJ_RETAIL_DETAILS.CHALLENGES.TEXT_2'
      },
      {
        text: 'SAHAJ_RETAIL_DETAILS.CHALLENGES.TEXT_3'
      }
    ],
    solutions: [
      {
        description: [
          {
            text: 'SAHAJ_RETAIL_DETAILS.SOLUTIONS.TEXT_1'
          },
          {
            text: 'SAHAJ_RETAIL_DETAILS.SOLUTIONS.TEXT_2'
          },
          {
            text: 'SAHAJ_RETAIL_DETAILS.SOLUTIONS.TEXT_3'
          },
          {
            text: 'SAHAJ_RETAIL_DETAILS.SOLUTIONS.TEXT_4'
          }
        ]
      }
    ],
    result: [
      {
        text: 'SAHAJ_RETAIL_DETAILS.RESULT.TEXT_1'
      },
      {
        text: 'SAHAJ_RETAIL_DETAILS.RESULT.TEXT_2'
      },
      {
        text: 'SAHAJ_RETAIL_DETAILS.RESULT.TEXT_3'
      },
      {
        text: 'SAHAJ_RETAIL_DETAILS.RESULT.TEXT_4'
      },
      {
        text: 'SAHAJ_RETAIL_DETAILS.RESULT.TEXT_5'
      }
    ],
    companyCategories: [
      {
        logo: Images.caseStudyPage.customerIcon,
        heading: 'SHARED.CUSTOMER',
        text: 'SAHAJ_RETAIL_DETAILS.COMPANY_NAME'
      },
      {
        logo: Images.caseStudyPage.industryImg,
        heading: 'SHARED.INDUSTRY',
        text: 'SAHAJ_RETAIL_DETAILS.INDUSTRY'
      },
      {
        logo: Images.caseStudyPage.countryImg,
        heading: 'SHARED.COUNTRY',
        text: 'SAHAJ_RETAIL_DETAILS.COUNTRY'
      },
      {
        logo: Images.caseStudyPage.segmentImg,
        heading: 'SHARED.SEGMENT',
        text: 'SAHAJ_RETAIL_DETAILS.ENTERPRISE'
      },
      {
        logo: Images.caseStudyPage.websiteLinkImg,
        heading: 'SHARED.WEBSITE',
        text: 'SAHAJ_RETAIL_DETAILS.WEBSITE_LINK'
      }
    ]
  },
  {
    id: 'autozilla',
    backGroundColor: 'black',
    foreGroundImage: Images.caseStudyForeGroundImg3,
    icon: Images.caseStudyPage.autozillaImg,
    customerOneLiner: 'AUTOZILLA_DETAILS.COMPANY_TITLE_TAG',
    customerDescription: 'AUTOZILLA_DETAILS.COMPANY_BODY_TEXT',
    iconClass: 'custom-style-img-3',
    name: 'AUTOZILLA_DETAILS.COMPANY_TITLE',
    description: 'AUTOZILLA_DETAILS.COMPANY_DESCRIPTION',
    companyLogo: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ5FVZ7NBLi3NHiyn1VgFupnclzICTN2H_9ag&s',
    challenges: [
      {
        text: 'AUTOZILLA_DETAILS.CHALLENGES.TEXT_1'
      },
      {
        text: 'AUTOZILLA_DETAILS.CHALLENGES.TEXT_2'
      },
      {
        text: 'AUTOZILLA_DETAILS.CHALLENGES.TEXT_3'
      }
    ],
    solutions: [
      {
        description: [
          {
            text: 'AUTOZILLA_DETAILS.SOLUTIONS.TEXT_1'
          },
          {
            text: 'AUTOZILLA_DETAILS.SOLUTIONS.TEXT_2'
          },
          {
            text: 'AUTOZILLA_DETAILS.SOLUTIONS.TEXT_3'
          },
          {
            text: 'AUTOZILLA_DETAILS.SOLUTIONS.TEXT_4'
          },
          {
            text: 'AUTOZILLA_DETAILS.SOLUTIONS.TEXT_5'
          }
        ]
      }
    ],
    result: [
      {
        text: 'AUTOZILLA_DETAILS.RESULT.TEXT_1'
      },
      {
        text: 'AUTOZILLA_DETAILS.RESULT.TEXT_2'
      },
      {
        text: 'AUTOZILLA_DETAILS.RESULT.TEXT_3'
      },
      {
        text: 'AUTOZILLA_DETAILS.RESULT.TEXT_4'
      },
      {
        text: 'AUTOZILLA_DETAILS.RESULT.TEXT_5'
      },
    ],
    companyCategories: [
      {
        logo: Images.caseStudyPage.customerIcon,
        heading: 'SHARED.CUSTOMER',
        text: 'AUTOZILLA_DETAILS.COMPANY_NAME'
      },
      {
        logo: Images.caseStudyPage.industryImg,
        heading: 'SHARED.INDUSTRY',
        text: 'AUTOZILLA_DETAILS.INDUSTRY'
      },
      {
        logo: Images.caseStudyPage.countryImg,
        heading: 'SHARED.COUNTRY',
        text: 'AUTOZILLA_DETAILS.COUNTRY'
      },
      {
        logo: Images.caseStudyPage.segmentImg,
        heading: 'SHARED.SEGMENT',
        text: 'AUTOZILLA_DETAILS.ENTERPRISE'
      },
      {
        logo: Images.caseStudyPage.websiteLinkImg,
        heading: 'SHARED.WEBSITE',
        text: 'AUTOZILLA_DETAILS.WEBSITE_LINK'
      }
    ]
  }
];
